import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import errors from './errors/store'
import userInfo from './userInfo/store'
import license from './license/store'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  modules: {
    errors,
    userInfo,
    license
  },
  strict: process.env.NODE_ENV !== 'production'
})
